import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { FormBuilderApiService } from '@features/client/form-builder/services/form-builder-api.service';

@Injectable({
  providedIn: 'root',
})
export class FormBuilderResolver {
  constructor(private readonly formBuilderApiService: FormBuilderApiService) {}

  public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    return this.formBuilderApiService.resolveFormBuilders();
  }
}
